// 商品カード全体をa:afterで覆ってリンクにしているため、商品タイトルのみをホバーで拾うために使用
(function () {
    let lastHeading = null;

    document.addEventListener('mousemove', (e) => {
      const heading = e.target.closest('.card__heading');

      // 前回の対象から外れたらクラスを外す（全走査しない）
      if (lastHeading && lastHeading !== heading) {
        lastHeading.classList.remove('is-title-hover');
      }

      // カード外なら終了
      if (!heading) {
        lastHeading = null;
        return;
      }

      const link = heading.querySelector('a.full-unstyled-link');
      if (!link) {
        lastHeading = heading;
        return;
      }

      // タイトル領域で判定
      const rect = heading.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;

      heading.classList.toggle('is-title-hover', inside);

      // 追跡更新
      lastHeading = heading;
    });
  })();